import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import CheckGroupMembershipTab from './ZIA/check-group-membership';
import AddUsersToGroupTab from './ZIA/add-users-to-group';
import RemoveUsersFromGroupTab from './ZIA/remove-users-from-group';
import DeleteGroupTab from './ZIA/delete-group';
import ListGroupMembersTab from './ZIA/list-group-members'
import ListUserGroups from './ZIA/list-user-groups';
import FilterIpsTab from './ZIA/filter-ips';

function ZIATab({ groups, verified, showVerifyWindow, setShowVerifyWindow, setVerifyOperation, setVerified, selectedTab, setSelectedTab, setZIASelectedTab }) {

    function onTabSelect(eventKey) {
        setSelectedTab(eventKey);
        setZIASelectedTab(eventKey);
    }

    return (
        <Tab.Container id="usersAndGroups" defaultActiveKey="addToGroup">
            <Nav justify variant="pills" className=' bg-dark-subtle justify-content-center rounded-2' onSelect={(eventKey) => onTabSelect(eventKey)}>
                <Nav.Item>
                    <Nav.Link eventKey="addToGroup">Add Users to Group</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="removeFromGroup">Remove Users from Group</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="deleteGroup">Delete Groups</Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey="listGroupMembers">List Group Members</Nav.Link>
                </Nav.Item>
                <Nav.Item >
                    <Nav.Link eventKey="listUserGroups">List User Groups</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="checkGroupMembership">Check Group Membership</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="filterIps">Filter IPs</Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content>
                <Tab.Pane eventKey="listGroupMembers">
                    <ListGroupMembersTab groups={groups} />
                </Tab.Pane>
                <Tab.Pane eventKey="addToGroup">
                    <AddUsersToGroupTab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
                <Tab.Pane eventKey="removeFromGroup">
                    <RemoveUsersFromGroupTab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
                <Tab.Pane eventKey="deleteGroup">
                    <DeleteGroupTab groups={groups} verified={verified} showVerifyWindow={showVerifyWindow} setShowVerifyWindow={setShowVerifyWindow} setVerifyOperation={setVerifyOperation} setVerified={setVerified} selectedTab={selectedTab} />
                </Tab.Pane>
                <Tab.Pane eventKey="listUserGroups">
                    <ListUserGroups groups={groups} />
                </Tab.Pane>
                <Tab.Pane eventKey="checkGroupMembership">
                    <CheckGroupMembershipTab groups={groups} />
                </Tab.Pane>
                <Tab.Pane eventKey="filterIps">
                    <FilterIpsTab />
                </Tab.Pane>

            </Tab.Content>
        </Tab.Container>


    );
}

export default ZIATab;